import React from 'react';

import { useForm } from 'react-hook-form';

import { Button, Stack, TextField } from '@mui/material';

import Accordion from '~/components/v2/common/Accordion/Accordion';

import { PromoRoleCreateProps } from '~/services/PromoService';

type PromoRoleAddProps = {
  createPromoRole: (role: PromoRoleCreateProps) => void;
};

type PromoRoleFormData = {
  description: string;
  roleName: string;
};

function PromoRoleAdd({ createPromoRole }: PromoRoleAddProps) {
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    reset,
  } = useForm<PromoRoleFormData>({
    mode: 'onChange',
  });

  const onSubmit = (data: PromoRoleFormData) => {
    createPromoRole({
      description: data.description,
      roleName: data.roleName,
      isActive: true,
    });
    reset();
  };

  return (
    <Accordion title="Add Promo Role" columns={1} defaultExpanded={false}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack direction="column" gap={2}>
          <Stack direction="row" spacing={2}>
            <TextField
              label="Role Name"
              {...register('roleName', { required: 'Role name is required' })}
              error={!!errors.roleName}
              helperText={errors.roleName?.message}
              fullWidth
            />
            <TextField
              label="Description"
              {...register('description', { required: 'Description is required' })}
              error={!!errors.description}
              helperText={errors.description?.message}
              fullWidth
            />
          </Stack>
          <Button disabled={!isValid} variant="contained" type="submit" sx={{ maxWidth: '120px' }}>
            Add
          </Button>
        </Stack>
      </form>
    </Accordion>
  );
}

export default PromoRoleAdd;
